import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "comment",
  listKey: "comments",
  itemKey: "comment",
  getAll: types.GET_ALL_COMMENTS,
  getAllResponse: types.GET_ALL_COMMENTS_RESPONSE,
});
